import type { AiAppCenterModule } from '../types'

export const visitingModule: AiAppCenterModule = {
  key: 'visiting',
  label: '上门服务',
  desc: '服务预约 / 订单派发 / 评价体系',
  path: '/visiting',
  homePath: '/visiting/dashboard',
  icon: 'ep:service',
  color: '#10b981'
}
